<nz-modal [nzTitle]="modalTitle" [nzVisible]="isVisible" (nzOnOk)="onSubmit()" (nzOnCancel)="handleCancel()"
  [nzOkLoading]="loader | async">
  <ng-template #modalTitle>
    <h3>Não Procede</h3>
  </ng-template>
  <ng-container *nzModalContent>
    <p>Digite um breve texto para justificar o motivo do não procedimento.</p>

    <form nz-form [formGroup]="notProceedForm" [nzLayout]="'vertical'" nz-col nzSm="24">
      <nz-form-item nz-col>
        <nz-form-label nzRequired>Motivo</nz-form-label>
        <nz-form-control nzErrorTip="Informe o motivo (mínimo 3 caracteres)">
          <textarea nz-input formControlName="maintenance_observation" placeholder="Descreva o motivo pelo qual não procede..."
            [nzAutosize]="{ minRows: 4, maxRows: 8 }"></textarea>
        </nz-form-control>
      </nz-form-item>
    </form>
  </ng-container>
  <ng-container *nzModalFooter>
    <button nz-button (click)="handleCancel()" type="button">Cancelar</button>
    <button nz-button (click)="onSubmit()" [disabled]="!notProceedForm.valid" [nzLoading]="(loader | async) ?? false"
      type="button" nzType="primary" nzDanger>
      Confirmar
    </button>
  </ng-container>
</nz-modal>